import { useDashboardListModel } from './dashboard-list.model'
import type { IDashboardListProps } from './dashboard-list.types'
import { DashboardListView } from './dashboard-list.view'

export const DashboardList = (props: IDashboardListProps) => {
  const dashboardListModel = useDashboardListModel(props)
  return <DashboardListView {...dashboardListModel} />
}
